export default {"src":"/_next/static/media/arrow-down-bold-white.fa1378f1.svg","height":24,"width":24};